import React from 'react'
import List from '../crud/list'
import { userEmailHydrator } from '../../fieldOptions/hydrators'

const columns = [
  { title: 'User', prop: 'user_id', references: 'admin/users', referenceProp: 'name' },
  { title: 'Action', prop: 'action' },
  { title: 'Record', prop: 'record' },
  { title: 'Record #ID', prop: 'record_id' },
  { title: 'Date', prop: 'action_date', format: 'date' }
]

const filters = [
  { name: 'Filter by user', prop: 'filters.user_id', type: 'autocomplete', references: 'admin/users', dataHydrator: userEmailHydrator, displayProp: 'displayVal', referenceProp: 'fullname', enabled: true },
  { name: 'Filter by action', prop: 'filters.action_ilike', type: 'text', enabled: true },
  { name: 'Filter by Record', prop: 'filters.record_ilike', type: 'text', enabled: true },
  { name: 'Date greater than', prop: 'filters.action_date_gte', type: 'datepicker', enabled: true },
  { name: 'Date less than', prop: 'filters.action_date_lte', type: 'datepicker', enabled: true }
]

const defaults = {
  order: [
    { column: 'action_date', direction: 'desc' }
  ]
}

const AdminAudit = (props) => (
  <List
    title='Admin Audit'
    apiPath='admin/admin_audit'
    columns={columns}
    filters={filters}
    defaults={defaults}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    buildMenuItems={() => []}
    withExport
    hideCreate
  />
)

export default AdminAudit
